export const STORE_USER_MOVEMENT_REQUEST = "STORE_USER_MOVEMENT_REQUEST";
export const STORE_USER_MOVEMENT_SUCCESS = "STORE_USER_MOVEMENT_SUCCESS";
export const STORE_USER_MOVEMENT_FAILURE = "STORE_USER_MOVEMENT_FAILURE";
